import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import DownloadIcon from 'icons/Download.icon';
import useClickCooldown from 'hooks/useClickCooldown';

import './PreviewModalDownloadButton.styles.scss';

type PreviewModalDownloadButtonProps = {
  className?: string;
  disabled?: boolean;
  resetKey?: string;
  shouldRender: boolean;
  onDownload: () => void;
};

const PreviewModalDownloadButton: React.FC<PreviewModalDownloadButtonProps> = (
  props,
) => {
  const { className, resetKey, disabled, shouldRender, onDownload } = props;

  const classes = classNames('preview-modal-download-button', className);

  const { t } = useTranslation();

  const [isDownloadDisabled, startDownloadCooldown] =
    useClickCooldown(resetKey);

  if (!shouldRender) return null;

  return (
    <Button
      className={classes}
      variant="outline"
      icon={DownloadIcon}
      disabled={isDownloadDisabled || disabled}
      onClick={() => {
        startDownloadCooldown();
        onDownload();
      }}
    >
      {t('download')}
    </Button>
  );
};

export default PreviewModalDownloadButton;
